import { render, staticRenderFns } from "./EvalIcon.vue?vue&type=template&id=900eede4&"
import script from "./EvalIcon.vue?vue&type=script&lang=js&"
export * from "./EvalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports